import { render, staticRenderFns } from "./EztReports.vue?vue&type=template&id=62e60b4e&scoped=true"
import script from "./EztReports.vue?vue&type=script&lang=js"
export * from "./EztReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e60b4e",
  null
  
)

export default component.exports